/**
 * @fileoverview gRPC-Web generated client stub for somewear.api.v1
 * @enhanceable
 * @public
 */
// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.29.0
// source: api/organization.proto
/* eslint-disable */
// @ts-nocheck
import * as grpcWeb from 'grpc-web';
import * as organization_proto_pb from '../organization_proto_pb'; // proto import: "organization_proto.proto"
import * as api_organization_pb from '../api/organization_pb'; // proto import: "api/organization.proto"
import * as api_device_pb from '../api/device_pb'; // proto import: "api/device.proto"
import * as api_workspace_pb from '../api/workspace_pb'; // proto import: "api/workspace.proto"
export class OrganizationClient {
    client_;
    hostname_;
    credentials_;
    options_;
    constructor(hostname, credentials, options) {
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname.replace(/\/+$/, '');
        this.credentials_ = credentials;
        this.options_ = options;
    }
    methodDescriptorGetWorkspaces = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetWorkspaces', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationWorkspacesRequest, api_organization_pb.GetOrganizationWorkspacesResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationWorkspacesResponse.deserializeBinary);
    getWorkspaces(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetWorkspaces', request, metadata || {}, this.methodDescriptorGetWorkspaces, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetWorkspaces', request, metadata || {}, this.methodDescriptorGetWorkspaces);
    }
    methodDescriptorCreateWorkspace = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/CreateWorkspace', grpcWeb.MethodType.UNARY, api_organization_pb.CreateOrganizationWorkspaceRequest, api_organization_pb.CreateOrganizationWorkspaceResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.CreateOrganizationWorkspaceResponse.deserializeBinary);
    createWorkspace(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/CreateWorkspace', request, metadata || {}, this.methodDescriptorCreateWorkspace, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/CreateWorkspace', request, metadata || {}, this.methodDescriptorCreateWorkspace);
    }
    methodDescriptorGetIdentities = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetIdentities', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationIdentitiesRequest, api_organization_pb.GetOrganizationIdentitiesResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationIdentitiesResponse.deserializeBinary);
    getIdentities(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetIdentities', request, metadata || {}, this.methodDescriptorGetIdentities, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetIdentities', request, metadata || {}, this.methodDescriptorGetIdentities);
    }
    methodDescriptorGetMembers = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetMembers', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationMembersRequest, api_organization_pb.GetOrganizationMembersResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationMembersResponse.deserializeBinary);
    getMembers(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetMembers', request, metadata || {}, this.methodDescriptorGetMembers, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetMembers', request, metadata || {}, this.methodDescriptorGetMembers);
    }
    methodDescriptorGetResources = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetResources', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationResourcesRequest, api_organization_pb.GetOrganizationResourcesResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationResourcesResponse.deserializeBinary);
    getResources(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetResources', request, metadata || {}, this.methodDescriptorGetResources, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetResources', request, metadata || {}, this.methodDescriptorGetResources);
    }
    methodDescriptorGetDevices = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetDevices', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationDevicesRequest, api_organization_pb.GetOrganizationDevicesResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationDevicesResponse.deserializeBinary);
    getDevices(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetDevices', request, metadata || {}, this.methodDescriptorGetDevices, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetDevices', request, metadata || {}, this.methodDescriptorGetDevices);
    }
    methodDescriptorGetIntegration = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetIntegration', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationIntegrationRequest, api_organization_pb.GetOrganizationIntegrationResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationIntegrationResponse.deserializeBinary);
    getIntegration(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetIntegration', request, metadata || {}, this.methodDescriptorGetIntegration, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetIntegration', request, metadata || {}, this.methodDescriptorGetIntegration);
    }
    methodDescriptorGetIntegrations = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetIntegrations', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationIntegrationsRequest, api_organization_pb.GetOrganizationIntegrationsResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationIntegrationsResponse.deserializeBinary);
    getIntegrations(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetIntegrations', request, metadata || {}, this.methodDescriptorGetIntegrations, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetIntegrations', request, metadata || {}, this.methodDescriptorGetIntegrations);
    }
    methodDescriptorUpdateOrganizationRole = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/UpdateOrganizationRole', grpcWeb.MethodType.UNARY, api_organization_pb.UpdateOrganizationRoleRequest, api_organization_pb.UpdateOrganizationRoleResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.UpdateOrganizationRoleResponse.deserializeBinary);
    updateOrganizationRole(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/UpdateOrganizationRole', request, metadata || {}, this.methodDescriptorUpdateOrganizationRole, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/UpdateOrganizationRole', request, metadata || {}, this.methodDescriptorUpdateOrganizationRole);
    }
    methodDescriptorGetDeviceUsage = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetDeviceUsage', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationDeviceUsageRequest, api_device_pb.GetDeviceUsageResponse, (request) => {
        return request.serializeBinary();
    }, api_device_pb.GetDeviceUsageResponse.deserializeBinary);
    getDeviceUsage(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetDeviceUsage', request, metadata || {}, this.methodDescriptorGetDeviceUsage, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetDeviceUsage', request, metadata || {}, this.methodDescriptorGetDeviceUsage);
    }
    methodDescriptorGetDataUsageForDevices = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetDataUsageForDevices', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationDataUsageForDevicesRequest, api_organization_pb.GetOrganizationDataUsageForDevicesResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationDataUsageForDevicesResponse.deserializeBinary);
    getDataUsageForDevices(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetDataUsageForDevices', request, metadata || {}, this.methodDescriptorGetDataUsageForDevices, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetDataUsageForDevices', request, metadata || {}, this.methodDescriptorGetDataUsageForDevices);
    }
    methodDescriptorGetOrganizationBillingInfo = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetOrganizationBillingInfo', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationBillingInfoRequest, api_organization_pb.GetOrganizationBillingInfoResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationBillingInfoResponse.deserializeBinary);
    getOrganizationBillingInfo(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetOrganizationBillingInfo', request, metadata || {}, this.methodDescriptorGetOrganizationBillingInfo, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetOrganizationBillingInfo', request, metadata || {}, this.methodDescriptorGetOrganizationBillingInfo);
    }
    methodDescriptorInviteOrganizationMembers = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/InviteOrganizationMembers', grpcWeb.MethodType.UNARY, api_organization_pb.InviteOrganizationMembersRequest, api_organization_pb.InviteOrganizationMembersResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.InviteOrganizationMembersResponse.deserializeBinary);
    inviteOrganizationMembers(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/InviteOrganizationMembers', request, metadata || {}, this.methodDescriptorInviteOrganizationMembers, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/InviteOrganizationMembers', request, metadata || {}, this.methodDescriptorInviteOrganizationMembers);
    }
    methodDescriptorRemoveOrganizationMembers = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/RemoveOrganizationMembers', grpcWeb.MethodType.UNARY, api_organization_pb.RemoveOrganizationMembersRequest, api_organization_pb.RemoveOrganizationMembersResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.RemoveOrganizationMembersResponse.deserializeBinary);
    removeOrganizationMembers(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/RemoveOrganizationMembers', request, metadata || {}, this.methodDescriptorRemoveOrganizationMembers, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/RemoveOrganizationMembers', request, metadata || {}, this.methodDescriptorRemoveOrganizationMembers);
    }
    methodDescriptorJoinOrganizationWorkspace = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/JoinOrganizationWorkspace', grpcWeb.MethodType.UNARY, api_organization_pb.JoinOrganizationWorkspaceRequest, api_workspace_pb.InviteMembersResponse, (request) => {
        return request.serializeBinary();
    }, api_workspace_pb.InviteMembersResponse.deserializeBinary);
    joinOrganizationWorkspace(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/JoinOrganizationWorkspace', request, metadata || {}, this.methodDescriptorJoinOrganizationWorkspace, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/JoinOrganizationWorkspace', request, metadata || {}, this.methodDescriptorJoinOrganizationWorkspace);
    }
    methodDescriptorCreateTakIntegration = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/CreateTakIntegration', grpcWeb.MethodType.UNARY, api_organization_pb.CreateOrganizationTakServerRequest, api_organization_pb.CreateOrganizationIntegrationResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.CreateOrganizationIntegrationResponse.deserializeBinary);
    createTakIntegration(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/CreateTakIntegration', request, metadata || {}, this.methodDescriptorCreateTakIntegration, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/CreateTakIntegration', request, metadata || {}, this.methodDescriptorCreateTakIntegration);
    }
    methodDescriptorCreateIntegration = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/CreateIntegration', grpcWeb.MethodType.UNARY, api_organization_pb.CreateOrganizationIntegrationRequest, api_organization_pb.CreateOrganizationIntegrationRequest, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.CreateOrganizationIntegrationRequest.deserializeBinary);
    createIntegration(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/CreateIntegration', request, metadata || {}, this.methodDescriptorCreateIntegration, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/CreateIntegration', request, metadata || {}, this.methodDescriptorCreateIntegration);
    }
    methodDescriptorRemoveIntegration = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/RemoveIntegration', grpcWeb.MethodType.UNARY, api_organization_pb.RemoveOrganizationIntegrationRequest, api_organization_pb.RemoveOrganizationIntegrationResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.RemoveOrganizationIntegrationResponse.deserializeBinary);
    removeIntegration(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/RemoveIntegration', request, metadata || {}, this.methodDescriptorRemoveIntegration, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/RemoveIntegration', request, metadata || {}, this.methodDescriptorRemoveIntegration);
    }
    methodDescriptorGetIntegrationAccounts = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetIntegrationAccounts', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationIntegrationAccountsRequest, api_organization_pb.GetOrganizationIntegrationAccountsResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationIntegrationAccountsResponse.deserializeBinary);
    getIntegrationAccounts(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetIntegrationAccounts', request, metadata || {}, this.methodDescriptorGetIntegrationAccounts, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetIntegrationAccounts', request, metadata || {}, this.methodDescriptorGetIntegrationAccounts);
    }
    methodDescriptorUpdateIntegrationRouting = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/UpdateIntegrationRouting', grpcWeb.MethodType.UNARY, api_organization_pb.UpdateOrganizationIntegrationRoutingRequest, api_organization_pb.GetOrganizationIntegrationAccountsResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationIntegrationAccountsResponse.deserializeBinary);
    updateIntegrationRouting(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/UpdateIntegrationRouting', request, metadata || {}, this.methodDescriptorUpdateIntegrationRouting, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/UpdateIntegrationRouting', request, metadata || {}, this.methodDescriptorUpdateIntegrationRouting);
    }
    methodDescriptorCreateResource = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/CreateResource', grpcWeb.MethodType.UNARY, api_organization_pb.CreateOrganizationResourceRequest, api_organization_pb.CreateOrganizationResourceResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.CreateOrganizationResourceResponse.deserializeBinary);
    createResource(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/CreateResource', request, metadata || {}, this.methodDescriptorCreateResource, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/CreateResource', request, metadata || {}, this.methodDescriptorCreateResource);
    }
    methodDescriptorCreateOrganizationApiClient = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/CreateOrganizationApiClient', grpcWeb.MethodType.UNARY, api_organization_pb.CreateOrganizationApiClientRequest, api_organization_pb.CreateOrganizationApiClientResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.CreateOrganizationApiClientResponse.deserializeBinary);
    createOrganizationApiClient(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/CreateOrganizationApiClient', request, metadata || {}, this.methodDescriptorCreateOrganizationApiClient, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/CreateOrganizationApiClient', request, metadata || {}, this.methodDescriptorCreateOrganizationApiClient);
    }
    methodDescriptorDeleteOrganizationApiClient = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/DeleteOrganizationApiClient', grpcWeb.MethodType.UNARY, api_organization_pb.DeleteOrganizationApiClientRequest, api_organization_pb.DeleteOrganizationApiClientResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.DeleteOrganizationApiClientResponse.deserializeBinary);
    deleteOrganizationApiClient(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/DeleteOrganizationApiClient', request, metadata || {}, this.methodDescriptorDeleteOrganizationApiClient, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/DeleteOrganizationApiClient', request, metadata || {}, this.methodDescriptorDeleteOrganizationApiClient);
    }
    methodDescriptorGetOrganizationApiClients = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetOrganizationApiClients', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationApiClientsRequest, api_organization_pb.GetOrganizationApiClientsResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationApiClientsResponse.deserializeBinary);
    getOrganizationApiClients(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetOrganizationApiClients', request, metadata || {}, this.methodDescriptorGetOrganizationApiClients, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetOrganizationApiClients', request, metadata || {}, this.methodDescriptorGetOrganizationApiClients);
    }
    methodDescriptorGetLicenseSummary = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetLicenseSummary', grpcWeb.MethodType.UNARY, api_organization_pb.GetOrganizationLicenseSummaryRequest, api_organization_pb.GetOrganizationLicenseSummaryResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetOrganizationLicenseSummaryResponse.deserializeBinary);
    getLicenseSummary(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetLicenseSummary', request, metadata || {}, this.methodDescriptorGetLicenseSummary, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetLicenseSummary', request, metadata || {}, this.methodDescriptorGetLicenseSummary);
    }
    methodDescriptorClaimOrganization = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/ClaimOrganization', grpcWeb.MethodType.UNARY, api_organization_pb.ClaimOrganizationRequest, organization_proto_pb.OrganizationRecord, (request) => {
        return request.serializeBinary();
    }, organization_proto_pb.OrganizationRecord.deserializeBinary);
    claimOrganization(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/ClaimOrganization', request, metadata || {}, this.methodDescriptorClaimOrganization, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/ClaimOrganization', request, metadata || {}, this.methodDescriptorClaimOrganization);
    }
    methodDescriptorConfirmClaimCode = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/ConfirmClaimCode', grpcWeb.MethodType.UNARY, api_organization_pb.ConfirmOrganizationClaimCodeRequest, api_organization_pb.ConfirmOrganizationClaimCodeResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.ConfirmOrganizationClaimCodeResponse.deserializeBinary);
    confirmClaimCode(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/ConfirmClaimCode', request, metadata || {}, this.methodDescriptorConfirmClaimCode, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/ConfirmClaimCode', request, metadata || {}, this.methodDescriptorConfirmClaimCode);
    }
    methodDescriptorSendCotToTakServer = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/SendCotToTakServer', grpcWeb.MethodType.UNARY, api_organization_pb.SendCotToTakServerRequest, api_organization_pb.SendCotToTakServerResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.SendCotToTakServerResponse.deserializeBinary);
    sendCotToTakServer(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/SendCotToTakServer', request, metadata || {}, this.methodDescriptorSendCotToTakServer, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/SendCotToTakServer', request, metadata || {}, this.methodDescriptorSendCotToTakServer);
    }
    methodDescriptorUpdateMemberPassword = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/UpdateMemberPassword', grpcWeb.MethodType.UNARY, api_organization_pb.UpdateOrganizationMemberPasswordRequest, api_organization_pb.UpdateOrganizationMemberPasswordResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.UpdateOrganizationMemberPasswordResponse.deserializeBinary);
    updateMemberPassword(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/UpdateMemberPassword', request, metadata || {}, this.methodDescriptorUpdateMemberPassword, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/UpdateMemberPassword', request, metadata || {}, this.methodDescriptorUpdateMemberPassword);
    }
    methodDescriptorGetDefaultSettings = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/GetDefaultSettings', grpcWeb.MethodType.UNARY, api_organization_pb.GetDefaultOrganizationSettingsRequest, api_organization_pb.GetDefaultOrganizationSettingsResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.GetDefaultOrganizationSettingsResponse.deserializeBinary);
    getDefaultSettings(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/GetDefaultSettings', request, metadata || {}, this.methodDescriptorGetDefaultSettings, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/GetDefaultSettings', request, metadata || {}, this.methodDescriptorGetDefaultSettings);
    }
    methodDescriptorUpdateDefaultSettings = new grpcWeb.MethodDescriptor('/somewear.api.v1.Organization/UpdateDefaultSettings', grpcWeb.MethodType.UNARY, api_organization_pb.UpdateDefaultOrganizationSettingsRequest, api_organization_pb.UpdateDefaultOrganizationSettingsResponse, (request) => {
        return request.serializeBinary();
    }, api_organization_pb.UpdateDefaultOrganizationSettingsResponse.deserializeBinary);
    updateDefaultSettings(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/somewear.api.v1.Organization/UpdateDefaultSettings', request, metadata || {}, this.methodDescriptorUpdateDefaultSettings, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/somewear.api.v1.Organization/UpdateDefaultSettings', request, metadata || {}, this.methodDescriptorUpdateDefaultSettings);
    }
}
//# sourceMappingURL=OrganizationServiceClientPb.js.map